// extracted by mini-css-extract-plugin
module.exports = {"Sorting":"Sorting_Sorting__2C56P"};